import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-05/lesson-23/task-04";

const task: Slide = {
  titleHtml:
    "The measurements and rating of sound insulation performance have been made on<br>different, randomly chosen building elements in a building. Specifically, the procedure<br>involved the assessment of airborne sound insulation of a party wall, impact sound<br>insulation of a floor, and the façade sound insulation of an outer wall in that building.<br>In one chosen room, the sound level due to service equipment was measured as well.<br>In all cases, the same numerical value of 40 dB (or dBA) has been obtained for the<br>appropriate single-number descriptors. What does that say about the sound<br>insulation performance of the investigated building elements?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
